<div class="mat-typography">
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>

        <tr>
            <td>
                External Users Resharing
                <mat-icon matTooltip="Prevents external users from resharing files, folders, and sites that they do not own.">info</mat-icon>
            </td>

            <td>
                <ng-container *ngTemplateOutlet="validatorRef"></ng-container>
            </td>

            <td>
                <ng-container *ngTemplateOutlet="formRef"></ng-container>
            </td>

            <td>
                <sway-baseline-status [errors]="errors"></sway-baseline-status>
            </td>
        </tr>
    </table>
</div>

<ng-template #validatorRef>
    <div class="validator">
            {{
                data.PreventExternalUsersFromResharing
                    ? "Prevent External Users From Resharing"
                    : "Allow External Users To Reshare"
            }}
    </div>
</ng-template>

<ng-template #formRef>
    <div class="form">
        <div class="field boolean">
            <mat-form-field appearance="fill">
                <mat-label>Status</mat-label>
                <mat-select [formControl]="control">
                    <mat-option value="any">Ignore</mat-option>
                    <mat-option [value]="true"
                        >Prevent External Users From Resharing</mat-option
                    >
                    <mat-option [value]="false"
                        >Allow External Users To Reshare</mat-option
                    >
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</ng-template>

